<template>
  <!-- Loading 组件：全屏遮罩层，支持显示/隐藏控制 -->
  <div v-if="visible" class="loading-overlay" @click.stop>
    <div class="loading-container">
      <!-- 旋转加载动画 -->
      <div class="loading-spinner"></div>
      <!-- 加载提示文字 -->
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
/**
 * Loading 加载组件
 * 功能：
 * 1. 支持显示/隐藏控制
 * 2. 全屏遮罩，阻止用户点击后面内容
 * 3. 层级最高，覆盖所有其他内容
 * 4. 自定义加载提示文字
 */
export default {
  name: 'Loading',
  props: {
    // 控制 Loading 显示/隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 加载提示文字
    text: {
      type: String,
      default: '加载中...'
    }
  },
  mounted() {
    // 组件挂载时，如果显示状态为 true，则禁止页面滚动
    if (this.visible) {
      this.disableScroll()
    }
  },
  watch: {
    // 监听 visible 状态变化，控制页面滚动
    visible(newVal) {
      if (newVal) {
        this.disableScroll()
      } else {
        this.enableScroll()
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前恢复页面滚动
    this.enableScroll()
  },
  methods: {
    /**
     * 禁止页面滚动
     */
    disableScroll() {
      document.body.style.overflow = 'hidden'
    },
    /**
     * 恢复页面滚动
     */
    enableScroll() {
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
/* Loading 遮罩层样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色遮罩 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 设置最高层级 */
}

/* Loading 内容容器 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 旋转加载动画 */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

/* 旋转动画关键帧 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载提示文字样式 */
.loading-text {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

/* 移动端适配 */
@media (max-width: 907px) {
  .loading-spinner {
    width: 36px;
    height: 36px;
    border-width: 3px;
    margin-bottom: 12px;
  }
  
  .loading-text {
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue